<template>
  <div id="app">
    <!-- <div class="head_app">
      <div class="box_app">
        <router-link to="/downloadFile">下载文件</router-link>
      </div>
      <div class="box_app">
        <router-link to="/specification">说明书</router-link>
      </div>
      <div class="box_app">
        <router-link to="/uploadWork">上传工单</router-link>
      </div>
      <div class="box_app">
        <router-link to="/handbook">工作手册</router-link>
      </div>
    </div> -->
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.head_app{
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.box_app{
  width: 5rem;
  height: 2rem;
  border-radius: .2rem;
  background: rgba(20, 20, 230, 0.651);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0 .1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue